import { useLoaderData } from 'react-router';

import { useWebsiteTrackingProxy } from '~/modules/tracking/hook/useWebsiteTrackingProxy';
import type { loader } from '~/routes/_app.project.$urlSegment._index';

/**
 * Click handler for the professional's own links inside the project's CMS copy.
 *
 * The project page's sibling of {@link import('~/ui-rocco/pages/details-page/revamp/hooks/use-product-link-tracking').useProductLinkTracking}:
 * a link written into the description goes out to the practice's site and has
 * to arrive carrying where it came from, the same as the Visit Website button
 * beside it.
 *
 * The reader's own id (`__apid`) is only known in the browser and identifies
 * them, so it is attached here on the click rather than baked into markup that
 * gets cached. The UTM parameters are in the markup as well, which is what
 * makes a copied or middle-clicked link carry the referral too.
 */
export const useProjectLinkTracking = () => {
    const { project } = useLoaderData<typeof loader>();

    return useWebsiteTrackingProxy(
        {
            professionalID: project.Professional.ID,
            professionalTitle: project.Professional.Title,
            itemType: 'Project',
            link: project.Professional.Link,
        },
        {
            attachUTM: true,
            processRelativeURL: true,
        },
    );
};
